import React, { memo, useCallback } from "react";
import { Form, Formik } from "formik";
import { createDriver } from "../../services/driver";
import {
  NEW_DRIVER_CREATED,
  PLEASE_FIX_ERRORS,
  SOMETHING_WENT_WRONG,
  ERROR_$,
} from "./messages";
import { validateDriverForm } from "./validators";
import CreateDriverForm from "./components/createDriverForm";
import { ValidationEffect } from "./components/validationEffect";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";
import useLoader from "../../hooks/useLoader";
import { SUBMIT_DRIVER_PROCESS } from "../../enums/loaderProcess";

const CreateDriverDialog = ({
  route = {},
  open,
  handleCreateNewDriver,
  showMessage,
  sections,
  vehicles,
  initialValues,
  formRef,
}) => {
  const { depot: depotCode, date } = useLocationQueryParams();

  const [showLoader, hideLoader] = useLoader();

  const showValidationError = useCallback(() => {
    showMessage(PLEASE_FIX_ERRORS);
  }, [showMessage]);

  const handleSubmitDriver = useCallback(
    async (values, { setSubmitting }) => {
      showLoader(SUBMIT_DRIVER_PROCESS);
      try {
        const { driverCode, password } = await createDriver({
          driver: values,
          depotCode,
          date,
          routeId: route.routeId,
        });
        showMessage(NEW_DRIVER_CREATED);
        handleCreateNewDriver({
          ...values,
          driverCode,
          isNewDriver: true,
          password,
        });
      } catch (e) {
        const message = e?.error?.message;
        showMessage(message ? ERROR_$(message) : SOMETHING_WENT_WRONG);
      } finally {
        hideLoader(SUBMIT_DRIVER_PROCESS);
      }
      setSubmitting(false);
    },
    [
      showLoader,
      hideLoader,
      showMessage,
      date,
      depotCode,
      route.routeId,
      handleCreateNewDriver,
    ]
  );

  return (
    <Formik
      innerRef={formRef}
      onSubmit={handleSubmitDriver}
      validate={validateDriverForm}
      initialValues={initialValues}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ isSubmitting, dirty, isValid }) => {
        return (
          <Form>
            <CreateDriverForm
              vehicles={vehicles}
              isSubmitting={isSubmitting}
              dirty={dirty}
              sections={sections}
            />
            <ValidationEffect
              isSubmitting={isSubmitting}
              isValid={isValid}
              callback={showValidationError}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default memo(CreateDriverDialog);
